<template>
  <div class="inline-block">{{ currentItem }}</div>
</template>

<script setup>
const props = defineProps(['items']);
const index = ref(0);
const charIndex = ref(0);
const currentItem = ref('');

const typingSpeed = 75;
const eraseSpeed = 25;
const delayBetweenCategories = 1000;

const shuffled = computed(() => {
  return useShuffle(props.items || []).filter(item => item !== 'Food & Beverages');
}); 

const startTyping = () => {
  const item = shuffled.value[index.value];
  if (charIndex.value < item?.length) {
    currentItem.value += item[charIndex.value++];
    setTimeout(startTyping, typingSpeed);
  } else {
    setTimeout(eraseTyping, delayBetweenCategories);
  }
};

const eraseTyping = () => {
  if (charIndex.value > 0) {
    charIndex.value--;
    currentItem.value = currentItem.value.slice(0, charIndex.value);
    setTimeout(eraseTyping, eraseSpeed);
  } else {
    index.value = (index.value + 1) % shuffled.value?.length;
    setTimeout(startTyping, typingSpeed);
  }
};

onMounted(startTyping);

watch(() => props.items, (newItems) => {
  currentItem.value = '';
});

</script>
